"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.csm = exports.Csm = void 0;
const constants_1 = require("../constants");
const models_1 = require("../models");
const window_1 = require("../utils/window");
const csm_provider_1 = require("./csm-provider");
const MONERA_AJAX_CSM_SCOPE_PREFIX = 'moneraAjax';
const USE_CLIENT_SIDE_TIMESTAMPS_FLAG_VALUE = '1';
class Csm {
    constructor(csmProvider) {
        this.ajaxScopeId = 0;
        this.provider = csmProvider;
        this.lastPageLoadScope = undefined;
    }
    getScope() {
        return this.ajaxScopeId === 0 ? undefined : MONERA_AJAX_CSM_SCOPE_PREFIX + this.ajaxScopeId;
    }
    markAjaxStartRequest() {
        if ((0, window_1.isClientSide)()) {
            this.ajaxScopeId++;
            this.provider.emitUet(constants_1.CsmMarker.TIME_OF_CLICK, this.getScope());
            if (window.deviceType === models_1.DeviceType.Mobile || window.deviceType === models_1.DeviceType.MShop) {
                this.provider.emitUet(constants_1.CsmMarker.MOBILE_TRANSITION_START, this.getScope());
            }
        }
    }
    markAjaxResponseReceived(requestId) {
        this.provider.emitUes(constants_1.CsmMarker.AJAX_RESPONSE_RECEIVED, this.getScope(), new Date());
        this.provider.emitUes(constants_1.CsmMarker.NEW_REQUEST_ID, this.getScope(), requestId);
        this.provider.emitUes(constants_1.CsmMarker.USE_CLIENT_SIDE_TIMESTAMPS_FOR_AJAX, this.getScope(), USE_CLIENT_SIDE_TIMESTAMPS_FLAG_VALUE);
    }
    emitPlatformTag() {
        this.provider.emitTag(`monera`);
        if (window.moneraPageType) {
            this.provider.emitTag(`monera:${window.moneraPageType.toLowerCase()}`);
        }
    }
    emitTenantStandardTag() {
        if (window.moneraTenant) {
            this.provider.emitTag(`monera:${window.moneraTenant.toLowerCase()}`);
            if (window.moneraPageType) {
                this.provider.emitTag(`monera:${window.moneraPageType.toLowerCase()}:${window.moneraTenant.toLowerCase()}`);
            }
        }
    }
    emitTenantCustomTag(customTags) {
        customTags.forEach((customTag) => customTag && this.provider.emitTag(`${customTag}`));
    }
    emitAboveTheFoldMetric() {
        this.provider.emitUet(constants_1.CsmMarker.ATF, this.getScope());
    }
    emitCriticalFeatureMetric() {
        this.provider.emitUet(constants_1.CsmMarker.CRITICAL_FEATURE, this.getScope());
    }
    emitFunctionalMetric() {
        this.provider.emitUet(constants_1.CsmMarker.FUNCTIONAL, this.getScope());
    }
    emitPageLoadComplete() {
        if (this.getScope() && this.getScope() !== this.lastPageLoadScope) {
            this.emitPlatformTag();
            this.emitTenantStandardTag();
            this.provider.emitTag('monera:ajax');
            this.provider.emitUex(constants_1.CsmMarker.PAGE_LOAD, this.getScope());
            this.lastPageLoadScope = this.getScope();
        }
    }
}
exports.Csm = Csm;
exports.csm = new Csm(new csm_provider_1.CsmProvider());
